import React, { useState, useEffect } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import Loader from "../../Utils/Loader";
import Search from "../../Search";
import CatlogueHeader from "../CatlogueHeader";
import Commonsharelist from "./Commonsharelist";

function GearwiseCatalogShare(props) {
  const [carList, setCarList] = useState([]);
  const [DealerData, setDealerData] = useState({ Name: "", Mobileno: "" });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const params = useParams();

  useEffect(() => {
    fetch(
      process.env.REACT_APP_API_ENDPOINT +
        "/api/BrandingProfile/GetBrandingProfile?Rand=" +
        params.dealerid
    )
      .then((response) => response.json())
      .then((res) => {
        if (res.Success === true) {
          setDealerData(res.Data);
        }
      });

    let obj = new URLSearchParams({
      Randomid: params.dealerid,
      gearid: params.gearid,
    }).toString();

    fetch(
      process.env.REACT_APP_API_ENDPOINT +
        "/api/Carmaster/GetdetailsofCarsbyRandomidGearid?" +
        obj
    )
      .then((response) => response.json())
      .then((res) => {
        setCarList(res.Data || []);
        setLoading(false);
      });
  }, [navigate, params.dealerid, params.gearid]);

  return (
    <div>
      {loading ? <Loader /> : null}
      <div style={{ marginTop: "-66px" }}>
        {params.brandshowing === "Wh_B" ? (
          <CatlogueHeader Datafromparent={DealerData} />
        ) : null}

        <div className="page-space">
          {/* <h3 className="text-center" style={{ color: "#ff002a" }}>
            Total Cars : {originalList.length}
          </h3>
          <Search
            dataFromParent={originalList}
            parentCallback={handleCallback}
          /> */}
          <Commonsharelist
            catloguelist={carList}
            DealerData={DealerData}
            Branding={params.brandshowing}
          />
        </div>
      </div>
    </div>
  );
}

export default GearwiseCatalogShare;
